import { Icon } from 'Components/shared/Icon';
import styled, { css } from 'styled-components';

const Overlay = styled.div<{ $isCentered?: boolean; $isFixed?: boolean }>`
  position: absolute;
  gap: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: ${({ $isFixed }) =>
    $isFixed ? 'min(170px, 40vh)' : 'min(100px, 40vh)'};
  z-index: 10;
  ${({ $isCentered }) =>
    $isCentered &&
    css`
      top: 50%;
      transform: translateY(-50%);
    `}
`;

const OverlayTitle = styled.h3`
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors?.text};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const WarningIcon = styled(Icon).attrs({ icon: 'warning-filled' })`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.warning} !important;
`;

const OverlayDescription = styled.p`
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors?.text};
  margin: 0;
`;

export const Styled = {
  Overlay,
  OverlayTitle,
  OverlayDescription,
  WarningIcon,
};
